<template>
  <div class="top_header">
    <div class="com">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="">
        <font>苏州来吧科技有限公司</font>
      </div>
      <div class="top_rig">
        <div class="nav">
          <!-- <div class="nav_c" :class="{active: index == cartitleIndex}" 
            v-for="(item,index) in tabList" :key="index" 
            @click="goHome(),cartitleTab(index)"
          >{{ item.name }}</div> -->
          <div class="nav_c" :class="{active: cartitleIndex == 0}" @click="goHome(),cartitleTab(0)">首页</div>
          <div class="nav_c" :class="{active: cartitleIndex == 1}" @click="goChanPinNengLi(),cartitleTab(1)">公司概况</div>
          <!-- <div class="nav_c" :class="{active: cartitleIndex == 2}" @click="goHangYeAnLi(),cartitleTab(2)">行业案例</div> -->
          <div class="nav_c" :class="{active: cartitleIndex == 3}" @click="goCallMe(),cartitleTab(3)">联系我们</div>

        </div>
        <!-- <div class="phone">
          <img src="@/assets/images/phone-p1.png" alt="">0591-9898998
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'',
  data(){
    return{
      cartitleIndex: 0,
      tabList:[
        {
          name:'首页'
        },
        {
          name:'产品与能力'
        },
        {
          name:'行业案例'
        },
        {
          name:'联系我们'
        },
      ]
    }
  },
  methods:{
    goHome(){
      this.$router.push('/Home')
    },
    goChanPinNengLi(){
      this.$router.push('/chanPinNengLi')
    },
    goHangYeAnLi(){
      this.$router.push('/hangYeAnLi')
    },
    goCallMe(){
      this.$router.push('/callMe')
    },
    cartitleTab(index) {
      this.cartitleIndex = index;
    },
  }
}
</script>


<style scoped lang="less">
.top_header {
  width: 100%;
  height: 87px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 9px 9px 0px rgba(4,84,216,0.11);
  position: absolute;
  top: 0;

  .com {
    width: 100%;
    height: 85px;
    display: flex;
    justify-content: space-between;

    .logo {
      display: flex;
      align-items: center;
      font {
        font-family: YouSheBiaoTiHei;
        font-weight: 400;
        font-size: 30px;
        color: #332C2B;
        margin-left: 10px;
      }
      img{
        width: 56px;
        height: 51px;
      }
    }

    .top_rig {
      align-items: center;
      display: flex;

      .nav {
        display: flex;
        padding-top: 17px;

        .nav_c {
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 20px;
          color: #332C2B;
          margin-left: 85px;
          height: 44px;
          padding-bottom: 20px;
          cursor: pointer;
          
          
          &.active{
            border-bottom: 3px solid #0569FF;
          }
        }
      }

      .phone {
        font-family: Adobe Heiti Std;
        font-weight: normal;
        font-size: 18px;
        color: #0096FF;
        display: flex;
        align-items: center;
        margin-left: 52px;
        img{
          margin-right: 7px;
        }
      }
    }
  }
}
</style>